import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_mt-3" }
const _hoisted_2 = { class: "_flex _ai-c" }
const _hoisted_3 = { class: "_flexcol" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { "format-key": "0" }
const _hoisted_7 = {
  key: 0,
  class: "_mt-2 _tc--base _flexwrap _ai-c _gap-1",
  "data-qa": "stretch-pay-text"
}
const _hoisted_8 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_localize = _resolveComponent("localize")
  const _component_base_label = _resolveComponent("base-label")
  const _component_installments_details = _resolveComponent("installments-details")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['_mt-3', {'gfu-field--disabled': !$options.canBePaidInInstallments}]),
      "data-qa": "payment-type:Installments"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['_cur-p _pa-3 _ba-2 _rounded--common', {'_bc--input': !$data.isSelected}, {'_bc--primary': $data.isSelected}, ]),
        onClick: _cache[1] || (_cache[1] = $event => ($options.onSelectPaymentType()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_checkbox_field, {
            modelValue: $data.isSelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.isSelected) = $event)),
            "show-label": false,
            name: "paymentTypeItem",
            class: "_mt-0 _mr-2",
            "read-only": !$options.canBePaidInInstallments,
            type: "radio",
            "data-qa": "select-checkbox"
          }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
          _createElementVNode("div", _hoisted_3, [
            (!$options.canBePaidInInstallments)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentTypeInstallmentsDisabledLabel), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : ($options.isInUpgradeMode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($options.upgradeInstallmentValueInformation), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($options.installmentValueInformation), 1 /* TEXT */)),
            _createVNode(_component_base_label, {
              class: "gfu-label--achievement",
              theme: "light"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_localize, {
                  resource: _ctx.Resources.Checkout.CheckoutPaymentTypeInstallmentsBadge
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString($options.numberOfInstallments), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        ($options.shouldDisplayInstallmentDetails)
          ? (_openBlock(), _createBlock(_component_installments_details, {
              key: 0,
              installments: $options.installments,
              "currency-symbol": $options.currencySymbol
            }, null, 8 /* PROPS */, ["installments", "currency-symbol"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    (!$options.canBePaidInInstallments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(), _createBlock(_component_localize, {
            key: $props.effectivePayableAmount,
            resource: _ctx.Resources.Checkout.CheckoutInstallmentsAvailabilityParagraph
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, _toDisplayString($options.remainingValueToUnlockInstallments), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])),
          _createVNode(_component_themed_image, {
            src: "/content/images/static/stretch-pay/installments-logo.svg",
            alt: "stretchPay",
            width: "91"
          }),
          _createVNode(_component_tooltip, {
            "icon-name": "circle-info",
            text: $options.tooltipText
          }, null, 8 /* PROPS */, ["text"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}